function renderBuildRelationshipDataTypesComponentTemplate({
  typeName
}: {
  typeName: string
}): string {
  return `export interface ${typeName} {
  id: string
  name?: string | null
  email?: string | null
}`
}

function renderBuildRelationshipDataTypesComponentDetailsTemplate({
  typeName
}: {
  typeName: string
}): string {
  return `export interface ${typeName} {
  id: string
  name?: string | null
  title?: string | null
  slug?: string | null
  label?: string | null
}`
}

export function renderBuildRelationshipDataTypesRenderer(
  request:
    | {
        kind: 'renderBuildRelationshipDataTypesComponentTemplate'
        props: {
          typeName: string
        }
      }
    | {
        kind: 'renderBuildRelationshipDataTypesComponentDetailsTemplate'
        props: {
          typeName: string
        }
      }
): string {
  switch (request.kind) {
    case 'renderBuildRelationshipDataTypesComponentTemplate':
      return renderBuildRelationshipDataTypesComponentTemplate(request.props)
    case 'renderBuildRelationshipDataTypesComponentDetailsTemplate':
      return renderBuildRelationshipDataTypesComponentDetailsTemplate(request.props)
  }

  throw new Error('Unsupported renderer request')
}
